const { addDomainPrefix } = require('../../shared/utils/addDomainPrefix');

const APP_NAME = 'choose_variation';
const DOMAIN_APP_NAME = addDomainPrefix(APP_NAME);

module.exports = {
    APP_NAME,
    DOMAIN_APP_NAME,
};
